import { render, staticRenderFns } from "./EventRaces.vue?vue&type=template&id=5953cfa8&"
import script from "./EventRaces.vue?vue&type=script&lang=js&"
export * from "./EventRaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports